import { useContext } from "react";

import { PrintAreaContext } from "./context";

export const usePrintArea = () => {
	return useContext(PrintAreaContext);
};
